import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { CpgReport } from '../../api/schema';
import { Highlights } from '../Highlights';
import { SummaryTabs } from './SummaryTabs';
import { AdSpendCard } from './AdSpendCard';
import { AIInsightsCard } from '../../../../../../components/shared/AIInsightsCard';
import { Campaign } from '@features/campaigns/subdomains/visitation/api';
import { useFeatures } from '@utils/hooks';
import { useCpgAIInsights } from '@features/ai-insights';

type MinimalCpgReport = Pick<
  CpgReport,
  | 'incrementalSalesLift'
  | 'projectedIncrementalSales'
  | 'totalProjectedSales'
  | 'uniqueUsers'
  | 'reportDate'
>;

export type SummaryCardProps = {
  report: MinimalCpgReport;
  allReports: CpgReport[];
  campaign: Pick<Campaign, 'id' | 'name' | 'startDate' | 'endDate'>;
};

export const SummaryCard = (props: SummaryCardProps) => {
  const features = useFeatures();

  const latestReportWithInsights = props.allReports.findLast(
    report => Array.isArray(report.aiInsights) && report.aiInsights.length > 0
  );

  const { cpgAiInsights } = useCpgAIInsights(
    latestReportWithInsights ?? null,
    'summary'
  );

  return (
    <Card>
      <CardHeader title="Summary" />
      <CardContent>
        <Grid container spacing="1rem">
          <Grid
            size={{
              md: 12,
              lg: 12,
            }}
          >
            <AdSpendCard
              campaign={props.campaign}
              reportDate={props.report.reportDate}
              incrementalSales={props.report.projectedIncrementalSales}
              totalSales={props.report.totalProjectedSales}
            />
          </Grid>

          <Grid size={12}>
            <AIInsightsCard
              testId="cpg-summary-ai-insights"
              title="Summary"
              aiInsights={cpgAiInsights}
              highlights={
                <Highlights
                  report={props.report}
                  campaignName={props.campaign.name}
                />
              }
            />
          </Grid>

          <Grid>
            <SummaryTabs
              allReports={props.allReports}
              enableSalesRate={features.cpgSalesRate}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
